<template>
  <div class="inner w100">
    <div :class="{'active-wallet': opened}" class="wallet-title"  @click="open">
        <div>
            <p class="grouped-title" v-if="groupByinnerClient">
            {{ i18n.lbl_client_group() }} - {{ innerWallet[0].ClientName }}
            </p>
            <p class="grouped-title" v-else>
            {{ i18n.lbl_direction_group() }} - {{ innerWallet[0].Description }}
            </p>
        </div>
        <div class="wallet-arrow-wrap">
            <p><span>{{ sumBalance }}</span>
            </p>
            <md-icon class="arrow-down-icon-aml  md-icon-size-065x">
                <svg height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" /></svg>
            </md-icon>
        </div>
    </div>
    <div v-show="opened">
      <div v-for="(group, index) in innerWallet" :key="`inner-groupt-${index}`">
        <div
          @click="setInnerActive(group)"
          class="text_medium protfolio-subwallet subwallets-flex accordioned"
        >
          <span class="wallet-field small-float">{{
            groupByinnerClient ? group.ClientName : group.Description
          }}</span>
          <span class="wallet-field">{{
            groupByinnerClient ? group.Description : group.ClientName
          }}</span>
          <div class="wallet-field">
            <span class="subwallet-balance">{{ group.Balance }}</span>
            <span>{{ group.Asset }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { i18n } from "@js/i18n";
export default {
  name: "InnerAccordion",
  emits: ["setInnerSubwallet"],
  props: {
    innerWallet: {
      type: Array,
      required: true
    },
    groupByinnerDescription: {
      type: Boolean,
      required: true
    },
    groupByinnerClient: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      opened: false,
      i18n
    };
  },
  computed: {
    sumBalance() {
      return Object.entries(
        this.innerWallet.reduce((acc, { Balance, Asset }) => {
          if (!acc[Asset]) {
            acc[Asset] = 0;
          }
          acc[Asset] += +Balance;
          return acc;
        }, {})
      )
        .map(([Asset, Balance]) => `${Balance} ${Asset}`)
        .join(" ");
    },
  },
  methods: {
    setInnerActive (group) {
      this.$emit('setInnerSubwallet', group)
    },
    open() {
      this.opened = !this.opened;
    },
  }
};
</script>

<style scoped lang="scss">
.inner {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.wallet-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}
.wallet-arrow-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.active-wallet {
  .arrow-down-icon-aml {
    transform: rotate(180deg);
  }
}
.small-float {
  padding-left: 20px;
}
.subwallets-flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .wallet-field {
    display: block;
    width: 33%;
    text-align: right;
    &:nth-child(2) {
      text-align: center;
    }
    &:first-child {
      text-align: left;
    }
  }
}
.w100 {
  width: 100%;
}
.grouped-title {
  font-weight: 600;
}

.accordioned {
  padding: 15px 5px;
  transition: all 0.4s ease-in-out;
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/InnerAccordion.vue